export default {
  back: 'Kembali',
  next: 'Selanjutnya',
  yes: 'Ya',
  no: 'Tidak',
  save: 'Simpan',
  status: 'Status',
  statusOptions: [
    {
      value: true,
      label: 'Active'
    },
    {
      value: false,
      label: 'Inactive'
    }
  ],
  currency: 'IDR'
}
